var ko = require('knockout'),
  assign = require('lodash/assign'),
  AUTHORIZATION_TYPE = require('_js/constants/authorization');

function CalculatorYears(params) {
  var self = this;
  this.excludeTimeunits = params.excludeTimeunits;
  this.period = ko.observableArray([]).subscribeTo('periodYears', true);
  this.downloadFileUrl = params.downloadFileUrl;

  if (params.parent) {
    this.API = params.parent.API;
  }
  this.testIndex = 1;

  var startAuth = window.authorizedAccountant
    ? AUTHORIZATION_TYPE.ACCOUNTANT
    : AUTHORIZATION_TYPE.AUDITOR;
  this.calculatorType = ko
    .observable(startAuth)
    .subscribeTo('authorizationType', true);

  this.endYear = ko.observable(0).subscribeTo('currentEndYear', true);

  this.startActiveIndex = 0;

  // Create the year range for the period. Maximum year is + 8 years from the current year.
  var maxYear = new Date().getFullYear() + 8;
  this.staticAllYears = [];
  for (var tmpYear = 2003; tmpYear < maxYear; tmpYear++) {
    this.staticAllYears.push({ Year: tmpYear, Active: false, Leave: false });
  }

  this.fullPeriod = ko.observableArray(this.staticAllYears);

  this.isLoading = ko.observable(true).subscribeTo('periodYearsLoading', true);

  this.showFuture = params.showFuture || false;
  this.showDocumentationDate = params.showDocumentationDate || false;
  this.mobileView = params.mobileView || false;

  // Use the width of the entire document on mobile.
  // Otherwise use the container as the width.
  this.documentWidth = this.mobileView
    ? $(document.body).width()
    : $('.year-container').width() - 1;

  // We assume the standard amount of years to display is three. Therefore we calculate the length of each year/period
  // as such.
  this.periodLength = ko.observable(this.documentWidth / 3);

  // Overkill in length, but should work.
  this.containerWidth = ko.observable(
    this.documentWidth * this.fullPeriod().length
  );

  // The start position of the visual period.
  this.position = ko.observable(0);

  // The visual period is the currently active period within fullPeriod.
  this.visualPeriod = ko.computed(function() {
    var firstPeriod = this.period()[0];

    if (this.mobileView) {
      return this.period();
    }
    if (firstPeriod && firstPeriod.Leave && firstPeriod.TotalHoursDone === 0) {
      return this.period().slice(1);
    } else {
      return this.period();
    }
  }, this);

  this.visualPeriod.subscribe(this.visualPeriodChange, this);
  this.visualPeriodChange();

  if (this.showDocumentationDate) {
    this.documentationDate = ko.computed(function() {
      var period = this.period();
      if (period.length < 1) {
        return '';
      }
      return (
        'Dokumentasjonsdato: 31.12.' +
        this.period()[this.period().length - 1].Year
      );
    }, this);
  }

  this.authorizationDate = params.authorizationDate;
  this.showAuthorizationDate = params.showAuthorizationDate;
  this.nextYear = ko.observable(new Date().getFullYear() + 1);
  this.showFuture = ko.computed(function() {
    var retValue = false;
    // If our parent says it's ok we show the future.
    if (params.showFuture) {
      // Now we can actually check to see if there actually is any point in showing the future.
      if (self.nextYear() > self.endYear()) {
        return true;
      }
    }
    return retValue;
  });

  this.hoursPlanned = ko.observable(0); //.subscribeTo('hoursPlanned', true);
  this.hoursShopping = ko.observable(0).subscribeTo('hoursShopping', true);
  this.nextHours = ko.computed(function() {
    // For next year, we only want to display planned hours and hours in shopping cart.
    return {
      done: 0,
      planned: this.hoursPlanned(),
      shopping: this.hoursShopping(),
      required: 0,
      missing: 0
    };
  }, this);
}

CalculatorYears.prototype.visualPeriodChange = function() {
  if (this.visualPeriod().length === 0) {
    return;
  }

  var setIndex = false;
  var periodIndex = 0;
  var newArr = [];

  for (var i = 0; i < this.fullPeriod().length; i++) {
    // Check to see if the first position of the visualPeriod matches the current fullPeriod position
    // (and setIndex is not set).
    if (
      !setIndex &&
      this.fullPeriod()[i].Year === this.visualPeriod()[0].Year
    ) {
      this.startActiveIndex = i;
      this.fullPeriod()[i].Active = true;
      setIndex = true;
      periodIndex++;
      this.visualPeriod()[0].Active = true;
      newArr.push(this.visualPeriod()[0]);
    }
    // If we still have matching visualPeriods with fullPeriod.
    else if (
      periodIndex < this.visualPeriod().length &&
      this.fullPeriod()[i].Year === this.visualPeriod()[periodIndex].Year
    ) {
      this.fullPeriod()[i] = assign(
        this.fullPeriod()[i],
        this.visualPeriod()[periodIndex]
      );
      this.visualPeriod()[periodIndex].Active = true;
      newArr.push(this.visualPeriod()[periodIndex]);
      periodIndex++;
    }
    // When there's no match between visualPeriod and fullPeriod.
    else {
      var tmpItem = this.staticAllYears[i];
      tmpItem.Active = false;
      newArr.push(tmpItem);
    }
  }

  this.fullPeriod(newArr);

  // If we're on a mobile we want to show hint of the previous/next year to the visualPeriod.
  if (this.mobileView) {
    this.periodLength(this.documentWidth / (this.visualPeriod().length + 1));
    this.position(
      this.periodLength() * this.startActiveIndex - this.periodLength() * 0.5
    );
  }
  // On desktop we only want to show the visualPeriod (plus the next year of the current year we're in).
  else {
    this.periodLength(this.documentWidth / this.visualPeriod().length);
    this.position(this.periodLength() * this.startActiveIndex);
  }
};

module.exports = CalculatorYears;
